import { FormattedMessage } from "react-intl";
import { SearchFilterUser } from "./searchFilterUser";
import { useState } from "react";
import { FetchAllUsers, UsersAuditViewModel } from "@mikros/library";
import { UserAuditDetailsDup } from "./userAuditDetailsDup";

export function UserAuditView() {
  const [userAuditModel, setUserAuditModel] = useState<UsersAuditViewModel>({
    useraudits: [],
    lastKey: "",
  });
  const [totalUserCount, setTotalUserCount] = useState<number>(0);
  const [searchActive, setSearchActive] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    branchName: "",
    department: "",
    location: "",
    branch: "",
    designation: "",
  });
  const [userFetchModel, setUserFetchModel] = useState<FetchAllUsers>({
    users: [],
    lastKey: "",
  });
  const [hasMoreData, setHasMoreData] = useState(true); // Track if more data is available
  return (
    <div className="mt-2">
      <div className="text-mk-primary-bright text-2xl font-semibold">
        <FormattedMessage id="analytics.userView.searchUsers" />
      </div>
      <div className="pb-[1%]"></div>

      <SearchFilterUser
        userAuditData={userAuditModel}
        userAuditDataFunction={setUserAuditModel}
        totalCount={totalUserCount}
        totalCountFunction={setTotalUserCount}
        search={searchActive}
        searchFunction={setSearchActive}
      formData={formData}
        formDataFunction={setFormData}
        hasMoreData={hasMoreData}
        hasMoreDataFunction={setHasMoreData}
        userData={userFetchModel}
        userDataFunction={setUserFetchModel}
      />
      <div className="pb-[2%]"></div>
      {/* <UserAuditDetails
        userAuditData={userAuditModel}
        userAuditDataFunction={setUserAuditModel}
        totalCount={totalUserCount}
        totalCountFunction={setTotalUserCount}
        search={searchActive}
        searchFunction={setSearchActive}
        formData={formData}
        formDataFunction={setFormData}
        hasMoreData={hasMoreData}
        hasMoreDataFunction={setHasMoreData}
      /> */}

      <UserAuditDetailsDup
        userAuditData={userAuditModel}
        totalCount={totalUserCount}
        totalCountFunction={setTotalUserCount}
        search={searchActive}
        searchFunction={setSearchActive}
        formData={formData}
        formDataFunction={setFormData}
        hasMoreData={hasMoreData}
        hasMoreDataFunction={setHasMoreData}
        userData={userFetchModel}
        userDataFunction={setUserFetchModel}
      />
    </div>
  );
}
